import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-03a8e11e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Congratulations!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "You’ve successfully created the team", -1))
const _hoisted_4 = { "data-test": "new-team-name" }
const _hoisted_5 = { class: "team-image-container image-margin" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Now that you’ve created a team, it’s time to level up!", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Click the button below and you will be directed to the ‘Team Lead area’.", -1))
const _hoisted_9 = ["href"]

import { Modal } from "uiv";
import { computed, nextTick, onMounted, ref } from "vue";
import { TeamApiModel } from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'create-team-modal',
  props: /*#__PURE__*/_mergeModels({
    team: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const model = _useModel(__props, "modelValue");

const modalLink = ref<HTMLAnchorElement>();

const goButtonLink = computed(() => {
  return `${window.location.origin}/home?view=TeamLeadArea&team=${props.team.id}`;
});

onMounted(() => {
  if (modalLink.value) {
    nextTick(() => {
      modalLink.value?.focus();
      modalLink.value?.blur();
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    header: false,
    footer: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("h2", _hoisted_4, _toDisplayString(props.team.name), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: props.team.imageUrl,
            alt: "team image",
            "data-test": "new-team-img"
          }, null, 8, _hoisted_6)
        ]),
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("a", {
          href: goButtonLink.value,
          class: "btn btn-primary-forward btn-center",
          "data-test": "new-team-invite-link",
          ref_key: "modalLink",
          ref: modalLink,
          tabindex: "0"
        }, "Go", 8, _hoisted_9)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})